import PropTypes from 'prop-types';
import Button from 'Components/Atoms/Button/Button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import deleteImage from 'assets/icon-delete.svg';

export default function DeleteItemDrawer(props) {
    const { text, itemName, description, onSubmit, onCancel, onError } = props;

    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('common');

    const handleDelete = async () => {
        if (processing) return;
        setProcessing(true);
        try {
            await onSubmit();
        } catch (error) {
            onError(error);
        } finally {
            setProcessing(false);
        }
    };

    return (
        <div className="flex flex-col h-full">
            <div className="grow text-center">
                <div className="mb-6 flex justify-center">
                    <img src={deleteImage} width={70} height={80} alt="" />
                </div>
                <h6>
                    {text} <strong>{itemName}</strong>
                </h6>
                <small className="text-gray-500">{description}</small>
            </div>
            <div className="sticky bottom-0 bg-white pt-2 pb-4 z-10">
                <div className="flex gap-2">
                    <Button className="grow" onClick={onCancel}>
                        {t('cancel')}
                    </Button>
                    <Button variant="primary" isBusy={processing} type="button" className="grow" onClick={handleDelete}>
                        {t('delete')}
                    </Button>
                </div>
            </div>
        </div>
    );
}

DeleteItemDrawer.propTypes = {
    text: PropTypes.string.isRequired,
    itemName: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};
